import React, { useState } from 'react';

const VehicleSelectionModal = ({ 
  isOpen, 
  onClose, 
  vehicles, 
  date, 
  onSelectVehicle,
  title = "Select Vehicle"
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!isOpen || !vehicles || vehicles.length === 0) {
    return null;
  }

  const handleSelect = () => {
    if (selectedIndex >= 0 && selectedIndex < vehicles.length) {
      onSelectVehicle(vehicles[selectedIndex]);
    }
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSelect();
    } else if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex(prev => Math.max(0, prev - 1));
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex(prev => Math.min(vehicles.length - 1, prev + 1));
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div 
        className="modal-content vehicle-selection-modal" 
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{title}</h3>
          <button 
            className="modal-close-btn" 
            onClick={onClose}
            aria-label="Close modal"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <p className="selection-date">
            Vehicles scheduled for <strong>{date}</strong>:
          </p>
          
          <div className="vehicle-list">
            {vehicles.map((vehicle, index) => (
              <div
                key={index}
                className={`vehicle-item ${index === selectedIndex ? 'selected' : ''}`}
                onClick={() => setSelectedIndex(index)}
              >
                <div className="vehicle-number">{index + 1}</div>
                <div className="vehicle-info">
                  <div className="vehicle-reg">{vehicle.reg}</div>
                  <div className="vehicle-details">
                    {vehicle.vehicle || 'Unknown Vehicle'}
                  </div>
                  <div className="vehicle-meta">
                    {vehicle.eventType === 'arrival' ? 'Drop-off' : 'Collection'}
                    {vehicle.contact && ` • ${vehicle.contact}`}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="selection-hint">
            Use arrow keys to navigate, Enter to select, or click on a vehicle
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handleSelect}
          >
            View Vehicle
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleSelectionModal;
